import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ArrowLeft } from "react-bootstrap-icons";

import Layout from 'components/Layout/Layout';

import RenderPart from "./help/RenderPart";

import { useNotifications } from "hoc/NotificationsContext";

import { useLocalStorage } from 'utils/storage';

import { formatDate, toLocalDate, fetchNotifications, readNotification } from 'services/notifications';

import "./styles.css";
// import "bootstrap/dist/css/bootstrap.min.css";

const Notifications = () => {
	const navigate = useNavigate();

	const { id } = useParams();

	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [showContent, setShowContent] = useState(false);

	const { unreadCount, setUnreadCount } = useNotifications();
	const [latestNotifications, setLatestNotifications] = useLocalStorage('latestNotifications', []);
	const [notifications, setNotifications] = useState([]);
	const [selectedNotification, setSelectedNotification] = useState(null);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
			if (window.innerWidth >= 768) setShowContent(false);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (!id) return;

		let notification = latestNotifications.find(n => n.uid == id);

		if (!notification) {
			notification = notifications.find(n => n.uid == id);
		}

		if (!notification) {
			// Optional: fetch single notification
			return;
		}

		setSelectedNotification(notification);

		if (isMobile) setShowContent(true);

		// Mark as read if needed
		if (!notification.read) {
			const readNotificationData = readNotification(id);

			setUnreadCount(unreadCount - 1);

			setNotifications(prev =>
				prev.map(n => (n.uid === id ? { ...n, read: true } : n))
			);

			setLatestNotifications(prev =>
				prev.map(n => (n.uid === id ? { ...n, read: true } : n))
			);
		}
	}, [id, isMobile, unreadCount]);

	useEffect(() => {
		if (!notifications.length) {
			fetchNotifications().then(data => {
				if (!data) return;

				setNotifications(data.data);
				setUnreadCount(data.unread_count);
			});
		}
	}, []);

	return (
		<Layout title="Notifications">
			<div className="row">

				{!isMobile || !showContent ? (
					<div className="col-md-4">
						<div
							className="card card-paddings container-height left-navigation"
						>
							<div className="card-body p-0 overflow-auto">
								<ul className="list-group list-group-flush">
									{notifications.map((notification, index) => (
										<li
											key={index}
											className={`list-group-item ${!isMobile ? 'list-group-item-action' : ''} ${!isMobile && selectedNotification && selectedNotification.uid === notification.uid ? "active" : ""} p-1`}
											style={{ cursor: "pointer" }}
											onClick={() => navigate(`/notifications/${notification.uid}`)}
										>
											<div className="d-flex justify-content-between">
												<small>{formatDate(notification.created_at)}</small>

												{!notification.read ? (<span
													className="badge rounded-pill bg-danger d-flex align-items-center justify-content-center"
													style={{
														fontSize: "0.5rem",
														pointerEvents: "none",
														lineHeight: "1",
														padding: "0.25em 0.4em",
													}}
												>
													new
												</span>) : null}

											</div>
											<span>
												{notification.details.title}
											</span>
										</li>
									))}

								</ul>
							</div>

						</div>
					</div>
				) : null}

				{(!isMobile || showContent) && (
					<div className="col-md-8">
						<div className="card container-height">

							{selectedNotification ? (
								<>
									<div className="card-header form-card-header-paddings no-background no-border">
										<div className="p-2">
											<h3>{selectedNotification.details.title}</h3>
										</div>
									</div>

									<div className="card-body form-card-body-paddings overflow-auto">

										<div className="d-flex justify-content-between">
											<span className="text-muted small">
												{toLocalDate(selectedNotification.created_at).toLocaleString([], {
													year: "numeric",
													month: "short",
													day: "numeric",
													hour: "2-digit",
													minute: "2-digit"
												})}
											</span>
										</div>

										{selectedNotification.details.parts?.length > 0 &&
											selectedNotification.details.parts.map((part, index) => {
												return <RenderPart key={index} item={part} />
											})
										}

									</div>


									{isMobile && (
										<div className="card-footer form-card-footer-paddings border-top no-background">
											<div className="d-flex justify-content-between">
												<button
													type="button"
													className="btn btn-secondary ms-auto"
													onClick={() => {
														setShowContent(false);

														navigate('/notifications');
													}}
												>
													<ArrowLeft className="me-2" />
													Back
												</button>
											</div>
										</div>
									)}
								</>
							) : (
								<div className="card-body d-flex align-items-center justify-content-center">
									<div
										className="text-center"
									>
										<p className="text-muted mt-3">No notification selected</p>
									</div>
								</div>
							)}
						</div>
					</div>
				)}


			</div>
		</Layout>
    );
};

export default Notifications;
